import React from "react";
import { Fragment } from "react";

import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { TemplateOfferingListingDayOffice } from "../template_offering_listing_day_office";
import { Text } from "../text";
import { faqsEN, faqsHE } from "./offering_wework_day_office";
import { useWeWorkAnalytics } from "./wework_analytics";
import { useWeWorkPartnerConfig } from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkListingDayOffice() {
  useWeWorkAnalytics();
  const { locale } = useI18n();
  const partnerConfig = useWeWorkPartnerConfig();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingDayOffice
        firstDayOfWeek={0}
        viewMoreLabel="Additional offices at this location"
        partnerConfig={{
          ...partnerConfig,
          title:
            locale.baseLanguageTag === "he"
              ? "גישה יומית למשרד פרטי"
              : "Daily Office",
        }}
        data={{
          faqs: locale.baseLanguageTag === "he" ? faqsHE : faqsEN,
          description:
            locale.baseLanguageTag === "he" ? (
              <DescriptionHE />
            ) : (
              <DescriptionEN />
            ),
        }}
      />
    </Fragment>
  );
}

function DescriptionEN() {
  return (
    <Container>
      <Text>
        WeWork Daily Office is a private office made available on-demand, with
        no long term commitment. Choose the location and capacity of your needs,
        and get to work! Whether you’re hybrid-working, need a space to
        brainstorm a new project with your team or just looking to refresh your
        office views, you’ll have a fully furnished private office, community,
        and amenities to work towards your goals.
      </Text>
      <Text>Reserve your spot, check in and get to work.</Text>
    </Container>
  );
}

function DescriptionHE() {
  return (
    <Container>
      <Text>
        כעת ניתן להזמין גישה יומית למשרד פרטי WeWork באמצעות מערכת On Demand,
        ללא התחייבות לטווח ארוך. בחרו במיקום ובמספר האנשים הרצוי בהתאם לצרכים
        שלכם וגשו לעבודה! בין אם אתם עובדים במודל היברידי, צריכים לעבוד על
        פרויקט חדש עם הצוות, או פשוט רוצים להתרענן עם מיקום עבודה חדש, תקבלו
        משרד פרטי ומרוהט, תהנו מקהילה ומכל המתקנים והשירותים שצריך כדי לקדם את
        המטרות שלכם.
      </Text>
      <Text>
        אז איך זה עובד? מזמינים משרד, מגיעים לצ'ק אין מהיר בבניין ומתחילים
        לעבוד.{" "}
      </Text>
    </Container>
  );
}
